<div [ngClass]="additionalClasses()" class="flex items-center">
  <lucide-angular [img]="icon()" size="16" class="mr-2 text-gray-500"></lucide-angular>
  <span>{{ text() }}</span>
</div>
